module.exports = __webpack_public_path__ + "baby_watercolor-floral_1.jpg";